import { cn } from "@/utils/cn";

const LOGO_SRC = `${import.meta.env.BASE_URL}market_iq_logo.png`;

type BrandLogoProps = {
  className?: string;
  imgClassName?: string;
  alt?: string;
};

/** Shared MarketIQ brand logo from `public/market_iq_logo.png`. */
export function BrandLogo({
  className,
  imgClassName,
  alt = "MarketIQ",
}: BrandLogoProps) {
  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      className={cn("shrink-0 object-contain", className, imgClassName)}
    />
  );
}
